import { render, staticRenderFns } from "./MasterMiscellaneousCharge.vue?vue&type=template&id=c8b4241e&scoped=true"
import script from "./MasterMiscellaneousCharge.vue?vue&type=script&lang=js"
export * from "./MasterMiscellaneousCharge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b4241e",
  null
  
)

export default component.exports